<template>
  <div class="card-function-bar">
    <div v-if="isCardRealShow" class="card-wrap">
      <div class="card-item card-user">
        <name-card :name-card-infor="data" @click="jumpTo(data.nameCard)" />
      </div>
      <div class="card-item card-telephone" :class="{ line: !bApp && !isToB }">
        <a
          :href="`tel:${data.telephone}`"
          data-stat-id="phone"
          :data-stat-ep="
            JSON.stringify({
              productId: data.insuranceTypeId,
            })
          "
        >
          <template v-if="bApp">{{ data.telephone }}</template>
          <template v-else>
            <i class="iconfont icon-phone_line" />
            <span>联系我</span>
          </template>
        </a>
      </div>
      <div
        v-show="isScreenCapture"
        class="card-item"
        :class="[bApp ? 'card-edit' : 'card-view']"
      >
        <a
          href="javascript:;"
          data-stat-id="edit"
          :data-stat-ep="
            JSON.stringify({
              productId: data.insuranceTypeId,
            })
          "
          @click="jumpTo(bApp ? data.nameCardEdit : data.nameCard)"
        >
          <span v-if="bApp" class="inner">编辑名片</span>
          <template v-else>
            <i class="iconfont icon-business_card" />
            <span>查看名片</span>
          </template>
        </a>
      </div>
    </div>
    <footer v-if="isBarShow" v-show="isScreenCapture" class="function-bar">
      <div class="function-inner">
        <template v-if="isTrades">
          <template v-if="bApp">
            <div
              v-if="isSupportRecordScreen && recordingState"
              class="function-hd"
            >
              <name-card v-if="recordingState" :name-card-infor="data" />
            </div>
            <btn-layer
              :is-policy-check="isPolicyCheck"
              :is-scheme-show="isSchemeShow"
              :is-trade="true"
              @invoke="handleInvoke"
            />
          </template>
          <template v-else>
            <a
              key="ljtb"
              class="btn insured"
              :href="
                data.trades[0].productInfo &&
                  data.trades[0].productInfo.shareTradeUrl
              "
              data-stat-id="lktb"
              :data-stat-ep="
                JSON.stringify({
                  cpId: data.trades[0].productInfo.tradeId,
                })
              "
            >立即投保</a>
          </template>
        </template>
        <template v-else>
          <template v-if="isSaShow">
            <div
              v-if="isSupportRecordScreen && recordingState"
              class="function-hd"
            >
              <name-card v-if="recordingState" :name-card-infor="data" />
            </div>
            <btn-layer
              :is-policy-check="isPolicyCheck"
              :is-scheme-show="isSchemeShow"
              :is-trade="false"
              @invoke="handleInvoke"
            />
          </template>
        </template>
      </div>
    </footer>
  </div>
</template>
<script>
import { PLANBOOK_PAGE_MAP } from '@/config/assets'
import { bApp, isBxs, isBroker, isToB, isWeCom, isMiniBankInsurance } from 'base/config'
import { getUrlParam, getUrlByAddingParam } from 'common/js/common'
import NameCard from './nameCard'
import BtnLayer from './childComponents/btnLayer'

export default {
  components: {
    NameCard,
    BtnLayer
  },
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    miniprogram: {
      type: Boolean,
      default: false
    },
    isSupportRecordScreen: {
      type: Boolean,
      default: false
    },
    isScreenCapture: {
      type: Boolean,
      default: false
    },
    isForPresentation: {
      type: Boolean,
      default: false
    },
    isTrades: {
      type: Boolean,
      default: false
    },
    recordingState: {
      type: Boolean,
      default: false
    },
    interactionOn: {
      type: Boolean,
      default: false
    },
    isPolicyCheck: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      bApp: bApp,
      isToB: isToB,
      telephone: '',
      isCardShow: true,
      isShowSameScreenGuide: false
    }
  },
  computed: {
    isCardRealShow () {
      const { isCardShow, data, isPolicyCheck } = this
      return isCardShow && data.photo && !isPolicyCheck && !isWeCom
    },
    isSchemeShow () {
      const { recordingState, interactionOn, miniprogram, isSupportRecordScreen } = this
      const hasSameScreenInterpretation = interactionOn && (!miniprogram || isMiniBankInsurance)
      return !recordingState && (hasSameScreenInterpretation || isSupportRecordScreen || isBxs)
    },
    isBarShow () {
      // 保单年检，c端 && 单个交易产品，不显示<投保按钮> => 不显示foot
      if (this.isPolicyCheck) {
        return !(this.isTrades && !bApp)
      } else {
        return (bApp || this.isTrades || isWeCom) && !this.isForPresentation
      }
    },
    isSaShow () {
      return bApp || isWeCom
    }
  },
  created () {
    const isCardShow = getUrlParam('nocard')
    if (isCardShow == 1 || isBroker) {
      this.isCardShow = false
    }
    const uuid = getUrlParam('uuid')
    const theme = getUrlParam('theme')
    const sourceFrom = JSON.stringify({ uuid, theme })
    this.data.nameCard = getUrlByAddingParam(
      {
        sourceFrom
      },
      this.data.nameCard
    )
    if (this.isPolicyCheck) {
      this.policyListUrl = `${PLANBOOK_PAGE_MAP.policyInspectionFamilyPolicy}?nw=1&cid=${getUrlParam('familyhead')}`
    }
  },
  methods: {
    showSameScreenGuide (bool) {
      this.isShowSameScreenGuide = bool
    },
    jumpTo (url) {
      if (!url) return
      location.href = url
    },
    handleClick (type) {
      this.$emit(type)
      if (type === 'interpretation') {
        window.WeiyiStatSDK.submit('jiangjie')
      }
    },
    handleInvoke (type) {
      // 交易-立即投保
      if (type === 'insured') {
        if (
          !this.data ||
          !Array.isArray(this.data.trades) ||
          !this.data.trades[0] ||
          !this.data.trades[0].productInfo
        ) {
          return
        }
        const tradeInfo = this.data.trades[0].productInfo
        window.WeiyiStatSDK.submit('lktb', {
          cpId: tradeInfo.tradeId
        })
        this.jumpTo(tradeInfo.tradeUrl)
        return
      }
      // 保单年检保存
      if (type === 'save') {
        this.jumpTo(this.policyListUrl)
        return
      }
      // 企微-引导分享
      if (type === 'share' && isWeCom && window.WeCom && WeCom.showTopArrow) {
        WeCom.showTopArrow()
        return
      }
      this.handleClick(type)
    }
  }
}
</script>

<style lang="postcss" scoped>
@import 'variable.css';

.card-function-bar {
  position: relative;
  width: 95.2%;
  margin: 0 auto 0.2rem;
  font-size: 0.26rem;
  border-radius: 6px;
  background-color: #fff;
  text-align: center;
  .after-bd-r:after {
    height: 40%;
    bottom: 30%;
    background-color: rgba(51, 51, 51, 0.4);
  }
  .card-wrap {
    width: 100%;
    display: flex;
    border-radius: 6px;
    overflow: hidden;
  }
}

.card-item {
  float: left;
  position: relative;
  background-color: #fff;
  > a {
    display: block;
    height: 1.2rem;
    line-height: 1.2rem;
    color: var(--primary-color-text);
  }
}

.card-user {
  width: 38.7%;
  padding-left: 0.3rem;
}

.card-telephone {
  width: 33%;
  text-align: right;
}

.card-edit,
.card-view {
  width: 28.3%;
}

.card-telephone,
.card-view {
  .iconfont {
    margin-right: 0.12rem;
    font-size: 0.36rem;
    line-height: 1;
    vertical-align: middle;
  }
  span {
    font-size: 0.28rem;
    vertical-align: middle;
    line-height: 1;
  }
}

.card-edit {
  span {
    display: inline-block;
    padding: 0.18rem 0.24rem;
    font-size: 0.26rem;
    line-height: 1.3;
    border-radius: 6px;
    background: var(--theme-primary-color);
    color: white;
  }
}

.line {
  &:before,
  &:after {
    @apply --bd-w;
    background-color: var(--primary-color-border);
    height: 58%;
    top: 21%;
  }
  &:before {
    left: 6%;
  }
  &:after {
    right: 6%;
  }
}

.function-bar {
  z-index: 100;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 0.14rem 0;
  box-sizing: content-box;
  font-size: 0.28rem;
  text-align: center;
  .function-inner {
    display: flex;
    padding-left: 0.17rem;
    padding-right: 0.17rem;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    /* .btn {
      margin-left: 0.2rem;
      white-space: nowrap;
      &:first-child {
        margin-left: 0;
      }
    } */
  }
  .function-hd {
    flex: 1;
    text-align: left;
    .iconfont {
      padding-left: 0.34rem;
    }
    p {
      font-size: 0.24rem;
    }
    .name-card {
      line-height: 36px;
    }
  }
  .function-bd {
    display: flex;
    flex: 2;
  }
  .record {
    display: inline-block;
    color: #333;
  }
  .btn {
    display: block;
    flex: 1;
    line-height: 34px;
    border-radius: 6px;
    border: 1px solid #ccc;
    &:last-child {
      flex: 2;
    }
  }
}

@media screen and (device-width <= 320px) {
  .card-function-bar {
    .card-telephone,
    .card-view {
      span {
        font-size: 0.24rem;
      }
    }
  }
}

@media screen and (min-width: 600px) {
  .function-bar {
    left: calc((100% - 480px) / 2);
    width: 480px;
  }
}
</style>

<style lang="postcss">
.function-hd {
  .name-card {
    .head {
      width: 0.7rem;
    }
    .info {
      padding-left: 0.84rem;
    }
  }
  .member {
    .name {
      line-height: 1;
    }
  }
}
</style>
